module.exports = __webpack_public_path__ + "imgs/flowhub.36370b87d8ebead3a49daff4f44a13c0.jpg";